import { Coins } from "lucide-react";
import { brl, dataBR } from "@/lib/api";
import { EmptyState, Surface } from "@/components/ds";
import { Stat, CommissionPill } from "./shared";

/** Consulta: valores e status vêm do registro histórico, nunca recalculados aqui. */
export const CreatorCommissions = ({ data }) => {
  const rows = data.commissions || [];
  const payouts = data.payouts || [];
  const reverted = rows.filter((r) => r.status === "ESTORNADA");
  const review = rows.filter((r) => r.status === "REVISAO");

  return (
    <div className="space-y-6" data-testid="creator-commissions">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Geradas" value={rows.length} hint="lançamentos no total"
              testid="creator-commission-count" />
        <Stat label="Pendentes" value={brl(data.pending_total)} hint="a receber"
              testid="creator-commission-pending" />
        <Stat label="Pagas" value={brl(data.paid_total)} hint="já repassadas"
              testid="creator-commission-paid" />
        <Stat label="Estornadas" value={brl(data.reverted_total)}
              hint={`${review.length} em análise`} testid="creator-commission-reverted" />
      </div>

      {rows.length === 0 ? (
        <EmptyState
          icon={Coins}
          title="Nenhuma comissão ainda"
          description="As comissões aparecem aqui quando o pedido é pago."
          testid="creator-commissions-empty"
        />
      ) : (
        <Surface className="p-4" data-testid="creator-commissions-list">
          <p className="font-display text-base">Lançamentos</p>
          <ul className="mt-3 divide-y divide-white/5">
            {rows.map((c) => (
              <li key={c.id} className="py-2.5" data-testid={`creator-commission-${c.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="min-w-0 truncate text-xs">
                    {c.order_number} · {c.product_name}
                    {c.variation_name ? ` · ${c.variation_name}` : ""} · {c.quantity}x
                  </span>
                  <span className="flex shrink-0 items-center gap-2">
                    <span className="font-num text-sm">{brl(c.amount)}</span>
                    <CommissionPill status={c.status} />
                  </span>
                </div>
                <p className="mt-0.5 text-[11px] text-muted-foreground">
                  {dataBR(c.created_at)} · {c.rate}% sobre {brl(c.base)} (preço antes do desconto)
                  {c.paid_at ? ` · pago em ${dataBR(c.paid_at)}` : ""}
                </p>
              </li>
            ))}
          </ul>
          {reverted.length > 0 && (
            <p className="mt-3 text-[11px] text-muted-foreground">
              Comissões estornadas são de pedidos cancelados e não entram no valor a receber.
            </p>
          )}
        </Surface>
      )}

      <Surface className="p-4" data-testid="creator-payouts">
        <p className="font-display text-base">Histórico de repasses</p>
        {payouts.length === 0 ? (
          <p className="mt-2 text-xs text-muted-foreground">Nenhum repasse registrado ainda.</p>
        ) : (
          <ul className="mt-3 divide-y divide-white/5">
            {payouts.map((p) => (
              <li key={p.id} className="flex items-center justify-between gap-2 py-2.5 text-xs"
                  data-testid={`creator-payout-${p.id}`}>
                <span className="min-w-0 truncate">
                  {dataBR(p.paid_at || p.created_at)} · {p.method || "PIX"}
                  {p.notes ? ` · ${p.notes}` : ""}
                </span>
                <span className="shrink-0 font-num">{brl(p.amount)}</span>
              </li>
            ))}
          </ul>
        )}
      </Surface>
    </div>
  );
};
